import { api, ensureApiAuthenticated } from '../services/api';

export interface SettingsAddress {
  name: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface ShippingSettings {
  buylistShipTo: SettingsAddress;
  buylistShipToSource: 'settings' | 'env';
  buylistShipToComplete: boolean;
  accountAddress: SettingsAddress;
  accountAddressSource: 'settings' | 'env';
  accountAddressComplete: boolean;
}

export interface SettingsResponse {
  settings: Record<string, unknown>;
  shipping: ShippingSettings;
}

const emptyAddress = (): SettingsAddress => ({
  name: '',
  street1: '',
  street2: '',
  city: '',
  state: '',
  zip: '',
  country: 'US',
});

export async function getSettings(): Promise<SettingsResponse> {
  await ensureApiAuthenticated();
  const { data } = await api.get<SettingsResponse>('/settings');
  return data;
}

export async function saveShippingSettings(body: {
  buylistShipTo: SettingsAddress;
  accountAddress: SettingsAddress;
}): Promise<{ ok: boolean; shipping: ShippingSettings }> {
  await ensureApiAuthenticated();
  const { data } = await api.put<{ ok: boolean; shipping: ShippingSettings }>(
    '/settings/shipping',
    body,
  );
  return data;
}

export { emptyAddress };
